export const COMMON_ATTACHMENTS_WIDGET_NAMESPACE = 'widget.common-attachments'
